// extracted by mini-css-extract-plugin
module.exports = {"container_dog":"dogdetails_container_dog__2mzby","dog_details":"dogdetails_dog_details__3VMmv"};